export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "ml-keyboard.worker-00bc56b885410ca513e5.worker.js");
}
